import DataTable from '@/containers/data_table_ml/DataTable';
import './TablePage.less';
import React, { useRef, useImperativeHandle } from 'react';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import { Form, message } from 'antd';
import ButtonML from '@/components/button_ml/ButtonML';
import { useDispatch } from 'dva';
import { hasUndefInObj } from '../../../../../utils/breUtils';
import webStorage from '@/utils/storageManager';

const HandleTabel = (props) => {
  // const data = useSelector((state) => state.tvfCondition.getTvfRuleList);
  const { inputList, versonVal, handleTest, cRef } = props;
  const dispatch = useDispatch();
  const unitInput = useRef(null);
  const brandId = webStorage.get('BRAND_CODE');
  const [form] = Form.useForm();
  const columns = [
    {
      title: '输入字段',
      dataIndex: 'desc',
      key: 'desc',
      width: 200,
      render: (text) => <span>{text}</span>,
    },
    {
      title: '输入值',
      dataIndex: 'operator',
      key: 'operator',
      width: 200,
      render: (text, record) => {
        return (
          <SingInputML
            height="37px"
            labelwidth="0px"
            inputWidth="100px"
            placeVal="请输入值"
            className="no_label"
            name={record.name}
            refs={unitInput}
          />
        );
      },
    },
  ];
  const hanleClick = () => {
    const formVal = form.getFieldsValue();
    const { version } = versonVal || {};
    const { strategyCode } = versonVal || {};
    console.log('versonVal', version, versonVal);
    if (JSON.stringify(formVal) === '{}' && inputList?.length > 0) {
      message.warning('请添加输入值');
      return;
    }
    if (hasUndefInObj(formVal, undefined) || hasUndefInObj(formVal, '')) {
      message.warning('请填写完整');
      return;
    }
    if (version === undefined || strategyCode?.length < 1) {
      message.warning('请选择决策图名称及版本号');
      return;
    }
    //查询exp
    dispatch({
      type: 'dgtTest/getGraphOutputList',
      payload: {
        values: {
          brandId: brandId,
          values: { ...formVal },
          ...versonVal,
        },
      },
      callback: (d) => {
        if (!d?.code) {
          message.success('执行成功');
        } else {
          message.error(d?.message);
          return;
        }
        handleTest(d);
      },
    });
  };
  const hanleReset = () => {
    form.resetFields();
  };
  // // 对测试列表进行筛选
  // const fetchData = useCallback(() => {
  //   let obj = {};

  //   (data || []).map((item) => {
  //     // 对多个的外部入参和系统参数进行过滤
  //     if (item.variableType1 === 'SYSTEM') {
  //       obj[item['element1Name']] = item['element1'];
  //     }
  //     if (item.variableType2 === 'SYSTEM') {
  //       obj[item['element2Name']] = item['element2'];
  //     }
  //   });
  //   let arr = [];
  //   for (let key in obj) {
  //     arr.push({ name: key, val: obj[key] });
  //   }
  //   setTableList(arr);
  // }, [data]);
  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);
  useImperativeHandle(cRef, () => {
    return {
      hanleReset,
    };
  });
  return (
    <Form form={form} name="unit">
      <DataTable
        border={true}
        className="demo-test"
        style={{
          // minWidth: '1547px',
          // minHeight: '400px',
          border: '1px solid #edf0f0',
        }}
        columns={columns}
        rowSelection={false}
        scroll={{ y: 'calc(50vh - 140px - 3rem)' }}
        dataSource={inputList}
        // loading={loading}
        // title={() => (
        //   <div className="rule_name">
        //     <span>规则名称</span>
        //     {name}
        //   </div>
        // )}
        footer={() => (
          <>
            <ButtonML
              size="large"
              value="执行"
              htmlType="submit"
              fontsize="16px"
              onClick={() => hanleClick()}
            />
            <ButtonML
              size="large"
              value="重置"
              htmlType="submit"
              fontsize="16px"
              onClick={() => hanleReset()}
            />
          </>
        )}
      />
    </Form>
  );
};
export default HandleTabel;
